// extracted by mini-css-extract-plugin
export var deleteModal = "_ex-0";